import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator } from '@angular/forms';

const MIN_AGE = 16;
const MAX_AGE = 120;

/**
 * Valida data de nascimento:
 * - Não pode ser data futura
 * - Idade mínima de 16 anos
 * - Idade máxima de 120 anos
 */
export function dateOfBirthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (v == null || v === '') return null;

    const birth = new Date(v);
    if (isNaN(birth.getTime())) return { dateOfBirth: 'invalid' };

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (birth >= today) return { dateOfBirth: 'future' };

    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;

    if (age < MIN_AGE) return { dateOfBirth: 'tooYoung' };
    if (age > MAX_AGE) return { dateOfBirth: 'tooOld' };

    return null;
  };
}

/** Diretiva para uso com ngModel em Template-driven Forms. */
@Directive({
  selector: '[appDateOfBirth]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: DateOfBirthValidatorDirective, multi: true }],
})
export class DateOfBirthValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return dateOfBirthValidator()(control);
  }
}
